export const hintConverter = (content: string[]): string[] => {
  return content.map((sentence) => {
    const isHintText = sentence.includes('---');
    if (isHintText) {
      const startSentence = sentence.replace('---', '<wb7-text class="hint-text" size="s">');
      return startSentence.replace('---', '</wb7-text>');
    }
    return sentence;
  });
};
